import React from "react";

const AccountGraph = ({ className, width = 41, height = 40 }) => {
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 41 40">
      <defs>
        <filter
          id="a"
          width="135.1%"
          height="136.1%"
          x="-17.6%"
          y="-18.1%"
          filterUnits="objectBoundingBox">
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path id="c" d="M6.5 14.5h25" />
        <filter
          id="b"
          width="115.4%"
          height="500%"
          x="-7.7%"
          y="-100%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="e" d="M8.5 21.5h23" />
        <filter
          id="d"
          width="116.7%"
          height="500%"
          x="-8.3%"
          y="-100%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="g" d="M3.5 7.5h30" />
        <filter
          id="f"
          width="119.4%"
          height="700%"
          x="-9.7%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="i" d="M3.5 28.5h30" />
        <filter
          id="h"
          width="119.4%"
          height="700%"
          x="-9.7%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="k" d="M16 18.5h28.5" />
        <filter
          id="j"
          width="122.4%"
          height="700%"
          x="-12.1%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="m" d="M-8 18.5h28.5" />
        <filter
          id="l"
          width="122.4%"
          height="700%"
          x="-12.1%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="o" d="M8 18.5h28.5" />
        <filter
          id="n"
          width="115.5%"
          height="500%"
          x="-8.6%"
          y="-100%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="q" d="M6.5 14.5h25" />
        <filter
          id="p"
          width="115.4%"
          height="500%"
          x="-7.7%"
          y="-100%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="s" d="M8.5 21.5h23" />
        <filter
          id="r"
          width="116.7%"
          height="500%"
          x="-8.3%"
          y="-100%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="u" d="M3.5 7.5h30" />
        <filter
          id="t"
          width="119.4%"
          height="700%"
          x="-9.7%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="w" d="M3.5 28.5h30" />
        <filter
          id="v"
          width="119.4%"
          height="700%"
          x="-9.7%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="y" d="M16 18.5h28.5" />
        <filter
          id="x"
          width="122.4%"
          height="700%"
          x="-12.1%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="A" d="M-8 18.5h28.5" />
        <filter
          id="z"
          width="122.4%"
          height="700%"
          x="-12.1%"
          y="-200%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1.5" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="C" d="M8 18.5h28.5" />
        <filter
          id="B"
          width="115.5%"
          height="500%"
          x="-8.6%"
          y="-100%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
        <path id="E" d="M0 18.5h28.5" />
        <filter
          id="D"
          width="115.5%"
          height="500%"
          x="-8.6%"
          y="-100%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="1"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
          <feOffset dy="1" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        filter="url(#a)"
        transform="translate(2 1)">
        <rect width="37" height="36" fill="#FFF" fillRule="nonzero" rx="2" />
        <g strokeLinecap="round">
          <use fill="#000" filter="url(#b)" xlinkHref="#c" />
          <use stroke="#1174BE" xlinkHref="#c" />
        </g>
        <g strokeLinecap="round">
          <use fill="#000" filter="url(#d)" xlinkHref="#e" />
          <use stroke="#1174BE" xlinkHref="#e" />
        </g>
        <g strokeLinecap="round">
          <use fill="#000" filter="url(#f)" xlinkHref="#g" />
          <use stroke="#1174BE" strokeWidth="3" xlinkHref="#g" />
        </g>
        <g strokeLinecap="round">
          <use fill="#000" filter="url(#h)" xlinkHref="#i" />
          <use stroke="#1174BE" strokeWidth="3" xlinkHref="#i" />
        </g>
        <g strokeLinecap="round" transform="rotate(90 30.5 18.5)">
          <use fill="#000" filter="url(#j)" xlinkHref="#k" />
          <use stroke="#1174BE" strokeWidth="3" xlinkHref="#k" />
        </g>
        <g strokeLinecap="round" transform="rotate(90 6.5 18.5)">
          <use fill="#000" filter="url(#l)" xlinkHref="#m" />
          <use stroke="#1174BE" strokeWidth="3" xlinkHref="#m" />
        </g>
        <g strokeLinecap="round" transform="rotate(90 22.5 18.5)">
          <use fill="#000" filter="url(#n)" xlinkHref="#o" />
          <use stroke="#1174BE" xlinkHref="#o" />
        </g>
        <g>
          <rect width="37" height="36" fill="#FFF" fillRule="nonzero" rx="2" />
          <g strokeLinecap="round">
            <use fill="#000" filter="url(#p)" xlinkHref="#q" />
            <use stroke="#1174BE" xlinkHref="#q" />
          </g>
          <g strokeLinecap="round">
            <use fill="#000" filter="url(#r)" xlinkHref="#s" />
            <use stroke="#1174BE" xlinkHref="#s" />
          </g>
          <g strokeLinecap="round">
            <use fill="#000" filter="url(#t)" xlinkHref="#u" />
            <use stroke="#1174BE" strokeWidth="3" xlinkHref="#u" />
          </g>
          <g strokeLinecap="round">
            <use fill="#000" filter="url(#v)" xlinkHref="#w" />
            <use stroke="#1174BE" strokeWidth="3" xlinkHref="#w" />
          </g>
          <g strokeLinecap="round" transform="rotate(90 30.5 18.5)">
            <use fill="#000" filter="url(#x)" xlinkHref="#y" />
            <use stroke="#1174BE" strokeWidth="3" xlinkHref="#y" />
          </g>
          <g strokeLinecap="round" transform="rotate(90 6.5 18.5)">
            <use fill="#000" filter="url(#z)" xlinkHref="#A" />
            <use stroke="#1174BE" strokeWidth="3" xlinkHref="#A" />
          </g>
          <g strokeLinecap="round" transform="rotate(90 22.5 18.5)">
            <use fill="#000" filter="url(#B)" xlinkHref="#C" />
            <use stroke="#1174BE" xlinkHref="#C" />
          </g>
          <g strokeLinecap="round" transform="rotate(90 14.5 18.5)">
            <use fill="#000" filter="url(#D)" xlinkHref="#E" />
            <use stroke="#1174BE" xlinkHref="#E" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AccountGraph;
